import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-24 pb-8 bg-background-100/60">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6">
              <Link to="/" onClick={scrollToTop} className="hover:text-primary-500 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">关于我们</span>
            </nav>

            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              关于 911黑料
            </h1>
            <p className="text-base text-foreground-600 leading-relaxed max-w-2xl">
              致力于揭露真相，还原事实，做最值得信赖的独立调查媒体平台。
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2 space-y-10">
                <div>
                  <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                    品牌介绍
                  </h2>
                  <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                    <p>
                      <strong className="text-foreground-900">911黑料</strong>成立于2023年，是一个专注于深度调查与真相揭露的独立媒体平台。我们的使命是撕开信息迷雾，为公众提供未经粉饰的真相。
                    </p>
                    <p>
                      在信息泛滥的时代，真正有价值的深度内容反而被淹没在碎片化资讯的汪洋之中。911黑料的诞生，正是为了填补这一空白——我们不追逐热点，我们挖掘热点背后的真相。
                    </p>
                    <p>
                      我们的编辑团队由来自调查记者、数据分析师、法律专家和前行业内部人士组成，每一位成员都拥有多年深耕各自领域的经验。我们坚持实地调查、交叉验证、多方取证的报道原则，确保每一篇报道都经得起时间的检验。
                    </p>
                    <p>
                      目前，911黑料已累计发布超过900篇深度报道，涵盖政界揭秘、商业内幕、娱乐圈黑料、科技爆料、社会万象等多个领域，全网累计阅读量突破3亿次。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                    我们的原则
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[
                      { icon: 'ri-shield-check-line', title: '真实可信', desc: '每篇报道均经过严格的事实核查与多方交叉验证，绝不发布未经证实的消息。' },
                      { icon: 'ri-eye-off-line', title: '深度挖掘', desc: '不满足于表面信息，深入调查事件背后的利益链条与运作机制。' },
                      { icon: 'ri-lock-line', title: '保护信源', desc: '对每一位爆料人的身份信息实施最高级别的保护，绝不泄露任何信源信息。' },
                      { icon: 'ri-scales-line', title: '客观公正', desc: '坚持第三方独立立场，不受任何商业利益或政治力量的影响。' },
                    ].map((item) => (
                      <div key={item.title} className="flex gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70">
                        <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                          <i className={`${item.icon} text-lg`}></i>
                        </div>
                        <div>
                          <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                          <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                    口碑声誉
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                    {[
                      { value: '900+', label: '深度报道' },
                      { value: '3亿+', label: '累计阅读' },
                      { value: '500万+', label: '忠实读者' },
                    ].map((stat) => (
                      <div key={stat.label} className="text-center p-5 bg-background-50 rounded-lg border border-background-200/70">
                        <p className="text-2xl font-heading font-bold text-primary-500">{stat.value}</p>
                        <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                  <div className="space-y-4">
                    {[
                      {
                        source: '《独立媒体观察》',
                        quote: '911黑料是近年来最值得关注的独立调查媒体之一，其报道的深度和广度在行业内首屈一指。',
                      },
                      {
                        source: '资深调查记者 张某某',
                        quote: '在碎片化阅读时代，911黑料依然坚持做深度内容，这种专业精神令人敬佩。',
                      },
                      {
                        source: '读者社区评选',
                        quote: '连续两年获评"最受读者信赖的独立资讯平台"，真实性和独立性获得了广泛认可。',
                      },
                    ].map((item) => (
                      <div key={item.source} className="p-4 bg-background-50 rounded-lg border border-background-200/70">
                        <p className="text-sm text-foreground-700 leading-relaxed mb-2">"{item.quote}"</p>
                        <p className="text-xs text-foreground-400">—— {item.source}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-4">
                    联系我们
                  </h3>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">爆料邮箱</p>
                        <p className="text-sm text-foreground-800 font-medium">tips@yrkcpte.cn</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                        <i className="ri-shield-keyhole-line"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">PGP公钥</p>
                        <p className="text-sm text-foreground-800 font-medium">联系我们获取</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                        <i className="ri-message-2-line"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-400">商务合作</p>
                        <p className="text-sm text-foreground-800 font-medium">biz@yrkcpte.cn</p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="bg-accent-100/60 rounded-lg p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 mb-3">
                    <i className="ri-alert-line text-lg"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    爆料须知
                  </h3>
                  <ul className="space-y-2 text-xs text-foreground-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-accent-600 mt-0.5"></i>
                      <span>请提供尽可能详细的证据材料</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-accent-600 mt-0.5"></i>
                      <span>爆料人身份信息将绝对保密</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-accent-600 mt-0.5"></i>
                      <span>建议使用PGP加密通讯</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-accent-600 mt-0.5"></i>
                      <span>编辑团队将在7个工作日内回复</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100/60">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                常见问题
              </h2>
            </div>
            <div className="space-y-3">
              {[
                {
                  q: '911黑料的内容来源是什么？',
                  a: '我们的内容主要来自三个方面：编辑团队的独立调查、内部线人爆料以及公开信息的深度挖掘与分析。所有报道均经过严格的事实核查流程。',
                },
                {
                  q: '如何向911黑料提供爆料线索？',
                  a: '您可以通过我们的爆料邮箱 tips@yrkcpte.cn 提交线索。我们强烈建议使用PGP加密通讯以保护您的身份安全。所有爆料人均受最高级别的匿名保护。',
                },
                {
                  q: '911黑料的报道是否受外部势力影响？',
                  a: '911黑料是完全独立的调查媒体平台，不接受任何可能影响编辑独立性的资助或广告。我们的报道立场仅基于事实和调查结果，不受任何商业或政治利益的左右。',
                },
                {
                  q: '如果发现报道有误，如何申请更正？',
                  a: '我们珍视报道的准确性。如果您发现我们的报道中有事实性错误，请通过 biz@yrkcpte.cn 联系我们，我们将在核实后进行更正并公开说明。',
                },
                {
                  q: '911黑料是否接受投稿？',
                  a: '我们欢迎高质量的调查报道投稿。请将您的稿件大纲或完整作品发送至 tips@yrkcpte.cn，编辑团队将进行评估并在14个工作日内给予回复。',
                },
              ].map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70">
                  <summary className="flex items-center justify-between cursor-pointer p-5 text-sm font-medium text-foreground-900 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于911黑料',
            description: '致力于揭露真相，还原事实，做最值得信赖的独立调查媒体平台。',
            inLanguage: 'zh-CN',
            publisher: {
              '@type': 'Organization',
              name: '911黑料',
              url: 'https://yrkcpte.cn/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '911黑料的内容来源是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的内容主要来自三个方面：编辑团队的独立调查、内部线人爆料以及公开信息的深度挖掘与分析。所有报道均经过严格的事实核查流程。',
                },
              },
              {
                '@type': 'Question',
                name: '如何向911黑料提供爆料线索？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过爆料邮箱 tips@yrkcpte.cn 提交线索，建议使用PGP加密通讯以保护身份安全。',
                },
              },
              {
                '@type': 'Question',
                name: '911黑料的报道是否受外部势力影响？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '911黑料是完全独立的调查媒体平台，不接受任何可能影响编辑独立性的资助或广告。',
                },
              },
              {
                '@type': 'Question',
                name: '如果发现报道有误，如何申请更正？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '请通过 biz@yrkcpte.cn 联系我们，我们将在核实后进行更正并公开说明。',
                },
              },
              {
                '@type': 'Question',
                name: '911黑料是否接受投稿？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '欢迎高质量调查报道投稿，请发送至 tips@yrkcpte.cn，编辑团队将在14个工作日内回复。',
                },
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://yrkcpte.cn/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
                item: 'https://yrkcpte.cn/about',
              },
            ],
          }),
        }}
      />
    </>
  );
}